import { render, staticRenderFns } from "./product-page-form.vue?vue&type=template&id=4012fb9b"
import script from "./product-page-form.vue?vue&type=script&lang=js"
export * from "./product-page-form.vue?vue&type=script&lang=js"
import style0 from "./product-page-form.vue?vue&type=style&index=0&id=4012fb9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports